import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { extendCommonGroupsStylesheet } from "@devowl-wp/web-cookie-banner";
import { BannerDottedGroup } from "./dottedGroup.js";
import { useBanner } from "../../../contexts/banner.js";
import { useBannerStylesheet } from "../../../hooks/banner/useBannerStylesheet.js";
const BannerDottedGroupList = ()=>{
    const { texts: { headline } } = useBanner();
    const { DottedGroupList, screenReaderOnlyClass } = useBannerStylesheet().extend(...extendCommonGroupsStylesheet);
    const { groups, decision: { showGroups } } = useBanner();
    return showGroups ? /*#__PURE__*/ _jsxs(DottedGroupList, {
        children: [
            /*#__PURE__*/ _jsx("legend", {
                className: screenReaderOnlyClass,
                children: headline
            }),
            groups.filter(({ items })=>!!items.length).map((group)=>/*#__PURE__*/ _jsx(BannerDottedGroup, {
                    group: group
                }, group.id))
        ]
    }) : null;
};
export { BannerDottedGroupList };
